import api from './api';

export default {
    getServices() {
        return api.get('/services');
    },

    getService(id) {
        return api.get(`/services/${id}`);
    }
};
